import { render, staticRenderFns } from "./videoContent.vue?vue&type=template&id=0e3a3b9c&scoped=true"
import script from "./videoContent.vue?vue&type=script&lang=js"
export * from "./videoContent.vue?vue&type=script&lang=js"
import style0 from "./videoContent.vue?vue&type=style&index=0&id=0e3a3b9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3a3b9c",
  null
  
)

export default component.exports